import React from "react";

export default function RfmModalBase({ open, title, onClose, children, footer }) {
    if (!open) return null;

    return (
        <div
            className="ord-modal-backdrop show"
            onClick={(e) => {
                if (e.target === e.currentTarget) onClose?.();
            }}
        >
            <div className="ord-modal ord-scope">
                <div className="ord-modal-header">
                    <h3 className="ord-modal-title">{title}</h3>
                    <button className="ord-btn ord-btn-secondary ord-btn-icon" type="button" onClick={onClose}>
                        <i className="bi bi-x-lg" />
                    </button>
                </div>

                <div className="ord-modal-body">{children}</div>

                {footer ? <div className="ord-modal-footer">{footer}</div> : null}
            </div>
        </div>
    );
}